import { exportFileTypes } from '../../../../../models/exportFileTypes';

export interface RoomStateReportFormModel {
  date: string | null;
  room_type_ids: Array<number>;
  occupancies_type: OccupancyEnum[];
  room_state: RoomStateEnum[] | null;
  file_type: exportFileTypes;
}

export enum OccupancyEnum {
  FREE = 'free',
  OCCUPAIED = 'occupaied',
  OOO = 'ooo',
  OOS = 'oos',
}

export enum RoomStateEnum {
  CLEAN = 'clean',
  DIRTY = 'dirty',
  INSPECTED = 'inspected',
}
